import indicadorReportSummary from "entity/Indicador/reports/IndicadorReportSummary";
import TableReportHelper from "report/helper";

export default async function perfReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null;
    }

    async function getChart(conformidade) {
        let un = parseFloat(conformidade).toFixed(0) + " un."

        return h.row(h.text(un, { alignment: "center", fontSize: 40, colSpan: 2 }),)
    }

    return indicadorReportSummary(indicador, visita, tipoName, params, getChart, "un.", "conformidade", true, /*showMeta: */false);
}
